import React from "react";
import Banner from "../../../assets/TodasSolicitacoesBanner.png";
import Fade from "@material-ui/core/Fade";

import "./styles.scss";

const BaseComponent = ({ children }) => {
  return (
    <Fade in>
      <div className="baseComponentSolicitacoes centralized">
        <div className="baseComponentSolicitacoes__component centralized">
          <div className="baseComponentSolicitacoes__component__item centralized">
            {children}
          </div>
        </div>
        <div
          className="baseComponentSolicitacoes__banner"
          style={{ backgroundImage: `url(${Banner})` }}
        ></div>
      </div>
    </Fade>
  );
};

export default BaseComponent;
